const indexItems = [
  {
    title: '暑期档专题',
    desc: '2026暑期热门影视剧全追踪',
    icon: 'ri-sun-line',
    count: '36篇',
    color: 'text-primary-500',
    bg: 'bg-primary-100',
  },
  {
    title: '热播剧追踪',
    desc: '在播热门剧集实时追更讨论',
    icon: 'ri-tv-2-line',
    count: '52篇',
    color: 'text-accent-500',
    bg: 'bg-accent-100',
  },
  {
    title: '综艺大盘点',
    desc: '热门综艺节目深度解析合集',
    icon: 'ri-slideshow-line',
    count: '28篇',
    color: 'text-primary-500',
    bg: 'bg-primary-100',
  },
  {
    title: '明星数据库',
    desc: '当红艺人动态与作品全收录',
    icon: 'ri-vip-crown-line',
    count: '64篇',
    color: 'text-accent-500',
    bg: 'bg-accent-100',
  },
  {
    title: '影视风向标',
    desc: '行业趋势与新片前瞻分析',
    icon: 'ri-compass-3-line',
    count: '19篇',
    color: 'text-primary-500',
    bg: 'bg-primary-100',
  },
  {
    title: '吃瓜时间线',
    desc: '按时间线梳理重大娱乐事件',
    icon: 'ri-timeline-view',
    count: '41篇',
    color: 'text-accent-500',
    bg: 'bg-accent-100',
  },
  {
    title: '年度大事件',
    desc: '娱乐圈年度重磅新闻回顾',
    icon: 'ri-calendar-event-line',
    count: '15篇',
    color: 'text-primary-500',
    bg: 'bg-primary-100',
  },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
              专题索引
            </h2>
            <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
              按主题快速浏览您感兴趣的吃瓜内容合集
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
            {indexItems.slice(0, 4).map((item) => (
              <div
                key={item.title}
                className="group bg-background-100 rounded-xl p-5 cursor-pointer transition-all duration-300 hover:scale-[1.02] border border-background-200/60"
              >
                <div className={`w-10 h-10 flex items-center justify-center rounded-lg ${item.bg} mb-3`}>
                  <i className={`${item.icon} text-xl ${item.color}`}></i>
                </div>
                <h3 className="text-sm font-medium text-foreground-800 mb-1">{item.title}</h3>
                <p className="text-xs text-foreground-500 mb-3">{item.desc}</p>
                <span className="text-xs font-medium text-primary-600 bg-primary-50 px-2 py-1 rounded-md whitespace-nowrap">
                  {item.count}
                </span>
              </div>
            ))}
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-5 mt-4">
            {indexItems.slice(4).map((item) => (
              <div
                key={item.title}
                className="group bg-background-100 rounded-xl p-5 cursor-pointer transition-all duration-300 hover:scale-[1.02] border border-background-200/60"
              >
                <div className={`w-10 h-10 flex items-center justify-center rounded-lg ${item.bg} mb-3`}>
                  <i className={`${item.icon} text-xl ${item.color}`}></i>
                </div>
                <h3 className="text-sm font-medium text-foreground-800 mb-1">{item.title}</h3>
                <p className="text-xs text-foreground-500 mb-3">{item.desc}</p>
                <span className="text-xs font-medium text-accent-600 bg-accent-50 px-2 py-1 rounded-md whitespace-nowrap">
                  {item.count}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}